import { BrowserStorageType } from "@front-shared/config/general.config"
import { BrowserStorageHelper } from "@front-shared/helpers/browserStorage.helper"

import { GENERAL_CONFIG } from "../config/general.config"
import { IntakeDemoFlow } from "../config/intakeDemo.config"
import type { IIntakeDemoState } from "../types/state.types"

export class IntakeDemoStateClass implements IIntakeDemoState {
    isAuthenticated = !!BrowserStorageHelper.get(
        GENERAL_CONFIG.browserStorageKeys.tokenKey,
        undefined,
        BrowserStorageType.sessionStorage,
    )
    currentFlow = IntakeDemoFlow.initialData
    result = null
}
